var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1762_7632)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1762_7632",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V16H16V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1762_7632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7959 1.3335H5.20927C2.7826 1.3335 1.33594 2.78016 1.33594 5.20683V10.7868C1.33594 13.2202 2.7826 14.6668 5.20927 14.6668H10.7893C13.2159 14.6668 14.6626 13.2202 14.6626 10.7935V5.20683C14.6693 2.78016 13.2226 1.3335 10.7959 1.3335Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05685 10.3867C6.92351 10.3867 6.79685 10.3334 6.70352 10.2401L4.81688 8.35339C4.62354 8.16006 4.62354 7.84006 4.81688 7.64672C5.01021 7.45339 5.33021 7.45339 5.52354 7.64672L7.05685 9.18006L10.4835 5.7534C10.6768 5.56007 10.9968 5.56007 11.1902 5.7534C11.3835 5.94673 11.3835 6.26673 11.1902 6.46006L7.41018 10.2401C7.31685 10.3334 7.19018 10.3867 7.05685 10.3867Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1762_7632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxActive);
export default __webpack_public_path__ + "static/media/checkbox-active.260547d8b52edb92479ba7a34a6428cf.svg";
export { ForwardRef as ReactComponent };